import useAppContext from "utilities/hooks/useAppContext";

type AgricultureStatsSectionView = {
    title: string;
    children: React.ReactNode | React.ReactNode[];
}

const AgricultureStatsSectionView = (props: AgricultureStatsSectionView) => {
    const context = useAppContext();

    return <>
        <div className="pt-4 border-b border-dashed theme-border">
            <h3>- {context.t(props.title)}</h3>
        </div>
        <div className="px-2">
            {props.children}
        </div>
    </>
}

export default AgricultureStatsSectionView;
